import * as types from './types';
import createFetchAction from '../createFetchAction';

export const actionCreators = {
  listAdminLocations: () => createFetchAction({
    method: 'GET',
    url: '/api/v1/admin/locations',
    startAction: types.LIST_ADMIN_LOCATIONS
  }),
  getAdminLocation: locationId => createFetchAction({
    method: 'GET',
    url: `/api/v1/admin/locations/${encodeURIComponent(locationId)}`,
    startAction: types.GET_ADMIN_LOCATION,
    ignore404: true
  }),
  updateAdminLocationSettings: (locationId, settings) => createFetchAction({
    method: 'PUT',
    url: `/api/v1/admin/locations/${encodeURIComponent(locationId)}/settings`,
    body: settings,
    startAction: types.UPDATE_ADMIN_LOCATION_SETTINGS,
    ignore404: true
  }),
  createAdminLocation: location => createFetchAction({
    method: 'POST',
    url: '/api/v1/admin/locations',
    body: location,
    startAction: types.CREATE_ADMIN_LOCATION,
    ignore404: true
  })
};